import {
    CartAddChangePOSTRequest,
    CartAddChangeSkuCommentPOSTRequest,
    CartApi,
    CartCheckoutPOSTRequest,
    CartGetRequest,
    CartRemovePOSTRequest,
    CartSetSkuDispatchDatePOSTRequest,
    CartSummary,
    Checkout,
    CheckoutConfirm,
} from 'microshop-api';
import { config } from './api';

const cartApi = new CartApi(config);

/**
 * The shipping option is not stored server side, so a call that reprices the cart and omits it gets
 * priced with the shop's first option. Required - though it may be undefined - so that is a decision
 * every caller has to make rather than one it can forget.
 */
type Priced<T> = T & { shippingOptionId: number | undefined };

const cart = {
    removeSku: (skuData: Priced<CartRemovePOSTRequest>): Promise<CartSummary> => cartApi.cartRemovePOST(skuData),
    changeSkuQuantity: (skuData: Priced<CartAddChangePOSTRequest>): Promise<CartSummary> =>
        cartApi.cartAddChangePOST(skuData),
    changeSkuComment: (skuData: Priced<CartAddChangeSkuCommentPOSTRequest>): Promise<CartSummary> =>
        cartApi.cartAddChangeSkuCommentPOST(skuData),

    fetch: (request: Priced<CartGetRequest>): Promise<CartSummary | undefined> => cartApi.cartGet(request),
    checkout: (): Promise<Checkout> => cartApi.cartGetCheckout(),
    checkoutConfirm: (checkout: CartCheckoutPOSTRequest): Promise<CheckoutConfirm> =>
        cartApi.cartCheckoutPOST(checkout),
    cartSetRequestedDispatchDate: (skuDate: CartSetSkuDispatchDatePOSTRequest): Promise<void> =>
        cartApi.cartSetSkuDispatchDatePOST(skuDate),
};

export { cart };
